import { getApiBaseUrl, DEFAULT_REMOTE_API_ORIGIN } from './apiBaseUrl'

/**
 * 积分充值 / 支付与开放平台同一域名（open.pluskeji.cn），路由与主站一致：
 * /asset/score-skus、/asset/score-order/confirm、/payment-record/scan_alipay
 *
 * 可选 VUE_APP_BILLING_API_BASE 覆盖；未设置时与 VUE_APP_API_BASE_URL 相同。
 */
export function getBillingApiBaseUrl() {
  const raw = process.env.VUE_APP_BILLING_API_BASE
  if (raw != null && String(raw).trim() !== '') {
    const v = String(raw).trim()
    if (v === '/') return ''
    return v.replace(/\/+$/, '')
  }
  return getApiBaseUrl()
}

export { DEFAULT_REMOTE_API_ORIGIN as DEFAULT_BILLING_API_ORIGIN }
